const FolyamatSection = () => {
  const steps = [
    {
      num: "1",
      title: "Rövid egyeztetés",
      desc: "Pár célzott kérdés: mit csinálsz, kinek, mi a fő ajánlat, mi számít nálad \"jó érdeklődőnek\"."
    },
    {
      num: "2",
      title: "Első verzió",
      desc: "Megkapod a landing struktúrát és a szöveget. Te átnézed: stimmel-e a hang, a hangsúly, a fókusz."
    },
    {
      num: "3",
      title: "Finomhangolás és élesítés",
      desc: "A visszajelzések alapján pontosítunk, és kész a landing, amit már tudsz használni."
    }
  ];

  return (
    <section id="folyamat" data-testid="folyamat-section" className="light-band py-20 md:py-28" aria-label="Weboldal készítés folyamata">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div>
          <h2 className="scroll-animate font-sora font-bold text-3xl sm:text-4xl lg:text-5xl text-ink-text text-center">
            Nem hetekig tartó honlap készítés —{" "}
            <span className="text-primary">hanem egy fókuszált rendszer</span>
          </h2>

          {/* Timeline */}
          <div className="mt-16 relative">
            {/* Connector line */}
            <div className="hidden md:block absolute top-24 left-0 right-0 h-1 bg-gradient-to-r from-primary via-accent to-primary rounded-full" />
            
            <div className="scroll-animate-stagger scroll-animate grid grid-cols-1 md:grid-cols-3 gap-8">
              {steps.map((step, i) => (
                <div key={i} className="relative">
                  <div className="card-light rounded-3xl p-8 text-center hover:-translate-y-1 transition-transform">
                    <div className="w-16 h-16 rounded-full bg-gradient-to-br from-primary to-accent flex items-center justify-center mx-auto mb-6 shadow-glow">
                      <span className="text-2xl font-bold text-white">{step.num}</span>
                    </div>
                    <h3 className="font-sora font-bold text-xl text-ink-text">{step.title}</h3>
                    <p className="mt-4 text-muted-text">{step.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Success pill */}
          <div className="scroll-animate mt-12 text-center">
            <span className="inline-block px-6 py-3 rounded-full bg-accent/10 text-accent font-medium">
              Nincs "projekt-köd". Végig tudod, hol tartunk és mi a következő lépés.
            </span>
          </div>

          <p className="scroll-animate mt-6 text-center text-muted-text">
            Általában <span className="font-semibold text-ink-text">2–5 munkanap</span>.
          </p>
        </div>
      </div>
    </section>
  );
};

export default FolyamatSection;
